
interface IAuthor {
    nameDisplay: string[];
    nameAuthor: string;
    titleAuthor: string;
    descriptionAuthor: string;
    linkAuthor?: string;
    linkIn?: string;
    imageAuthor: string;
}
export const authorsData: IAuthor[] = [
    {
        nameDisplay: ["Nguyễn Thị Lộc"],
        nameAuthor: "Nguyễn Thị Lộc",
        titleAuthor: "Trưởng phòng Chiến lược Nội dung",
        descriptionAuthor:
            "Với hơn 10 năm kinh nghiệm trong quản lý bán hàng và thương mại điện tử, tôi định hướng chiến lược nội dung tại Sapo, đảm bảo từng bài viết đều chính xác, chuyên sâu và mang lại giá trị thực tiễn, giúp nhà bán hàng tối ưu hiệu suất kinh doanh.",
        linkAuthor: "https://www.sapo.vn/blog/quy-trinh-bien-tap-noi-dung#nguyen-thi-loc",
        linkIn: "",
        imageAuthor: "",
    },
    {
        nameDisplay: ["Vân ĐK", "Vân DK"],
        nameAuthor: "Đào Khánh Vân",
        titleAuthor: "Biên tập viên",
        descriptionAuthor:
            "Hơn 7 năm biên tập nội dung về bán hàng và chuyển đổi số, tôi phân tích chuyên sâu và truyền tải thông tin phức tạp thành nội dung dễ hiểu, giúp nhà bán hàng tối ưu quy trình và nâng cao năng lực cạnh tranh.",
        linkAuthor: "https://www.sapo.vn/blog/quy-trinh-bien-tap-noi-dung#dao-khanh-van",
        linkIn: "https://www.linkedin.com/in/v%C3%A2n-%C4%91%C3%A0o-kh%C3%A1nh-87030a352/",
        imageAuthor: "/images/chi-tiet/author/van-dao-khanh.png",
    },
    {
        nameDisplay: ["Việt Trinh"],
        nameAuthor: "Vũ Thị Việt Trinh",
        titleAuthor: "Biên tập viên",
        descriptionAuthor:
            "Với 5 năm kinh nghiệm biên tập mảng thương mại điện tử và phần mềm, tôi ứng dụng dữ liệu và AI để tạo ra nội dung chuyên sâu, hỗ trợ nhà bán hàng nâng cao hiệu suất và tiết kiệm chi phí vận hành.",
        linkAuthor: "https://www.sapo.vn/blog/quy-trinh-bien-tap-noi-dung#vu-thi-viet-trinh",
        linkIn: "https://www.linkedin.com/in/vi%E1%BB%87t-trinh-b54947262/",
        imageAuthor: "/images/chi-tiet/author/trinh-vu-thi-viet.png",
    },
    {
        nameDisplay: ["Thu Giang", "Đức Anh", "Mai Linh", "Minh PTX", "Lê Viết Vinh"],
        nameAuthor: "Nguyễn Thu Giang",
        titleAuthor: "Biên tập viên",
        descriptionAuthor:
            "Dựa trên nền tảng nghiên cứu nội dung kinh doanh, tôi có hơn 5 năm kinh nghiệm xây dựng chiến lược và triển khai bài viết giúp nhà bán hàng nắm bắt xu hướng, tối ưu hoạt động và ra quyết định hiệu quả.",
        linkAuthor: "https://www.sapo.vn/blog/quy-trinh-bien-tap-noi-dung#nguyen-thu-giang",
        linkIn: "https://www.linkedin.com/in/giang-nguy%E1%BB%85n-thu-2a49a3351/",
        imageAuthor: "/images/chi-tiet/author/thu-giang-nguyen.png",
    },
    {
        nameDisplay: ["Hà PT5"],
        nameAuthor: "Phạm Thu Hà",
        titleAuthor: "Biên tập viên",
        descriptionAuthor:
            "Là biên tập viên trong lĩnh vực marketing và bán hàng với 5 năm kinh nghiệm, tôi tập trung sản xuất nội dung chất lượng, cập nhật xu hướng, mang lại giá trị ứng dụng cao cho nhà bán hàng phát triển bền vững.",
        linkAuthor: "https://www.sapo.vn/blog/quy-trinh-bien-tap-noi-dung#pham-thu-ha",
        linkIn: "https://www.linkedin.com/in/thu-h%C3%A0-ph%E1%BA%A1m-621644219/",
        imageAuthor: "/images/chi-tiet/author/thu-ha-pham.png",
    },
]
export function getAuthorInfo(name: string): IAuthor | undefined {
    const matchedAuthor = authorsData.find((author) =>
        author.nameDisplay.some((n) => name.includes(n))
    );
    return matchedAuthor || authorsData.find(a => a.nameAuthor === "Nguyễn Thu Giang")!;
}